import React from 'react';
import { motion } from 'framer-motion';
interface CaseStudy {
  name: string;
  headline: string;
  description: string;
  image: string;
  imageAlt: string;
  stats?: {
    value: string;
    label: string;
  }[];
}
const CASE_STUDIES: CaseStudy[] = [{
  name: 'Home of The Good Shepherd',
  headline: 'Home of The Good Shepherd Experiences Increased Traffic & Leads',
  description: 'Home of The Good Shepherd had two main goals for their new website: increase leads for their enhanced assisted living, assisted living, and memory care communities, and increase applicant awareness of their job openings. Our award-winning team developed a beautiful, custom-coded site that delivered on both.',
  image: 'https://cdn.magicpatterns.com/uploads/iWjqJte7eG2CbTFTtYCZ3b/home-of-good-shepherd-full.png',
  imageAlt: 'Laptop and phone displaying the Home of The Good Shepherd website',
  stats: [{
    value: '80%',
    label: 'Increase in Leads'
  }, {
    value: '157%',
    label: 'Increase in Job Applications'
  }]
}, {
  name: 'Loudonville Assisted Living',
  headline: 'Loudonville Assisted Living Builds Warmth & Trust Online',
  description: 'After 50+ years serving its community, Loudonville Assisted Living needed a website that matched the quality of its care. We built a custom, ADA-compliant, SEO-optimized site that showcases their amenities and approach to care, positioning them for continued growth.',
  image: 'https://cdn.magicpatterns.com/uploads/3z1RESX6FPgKnKL4z16shG/loudonville-cover.png',
  imageAlt: 'Laptop and phone displaying the Loudonville Assisted Living website',
  stats: [{
    value: '14%',
    label: 'Growth in Organic Sessions'
  }, {
    value: '11%',
    label: 'More Engaged Time on Site'
  }, {
    value: 'WON',
    label: 'Web Excellence Award in Two Categories'
  }]
}];
export function ResultsSection() {
  return <section className="w-full bg-white" data-id="element-113" data-mp="3ezu1nexxy41m">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8" data-id="element-114" data-mp="3iykn2ot1nx8w">
        <div className="flex flex-col items-center text-center" data-id="element-115" data-mp="q4m1r5pjj2v7">
          <h2 className="font-display text-[1.75rem] font-bold leading-tight text-[var(--color-navy)] sm:text-3xl" data-id="element-116" data-mp="q6ykhl34hh9b">
            Senior Living Results That Speak for Themselves
          </h2>
          <span className="mt-4 h-1 w-16 rounded-full bg-[var(--color-lime)]" aria-hidden="true" data-id="element-117" data-mp="z6ve814dd6b8" />
        </div>
        <div className="mt-14 flex flex-col gap-16 sm:gap-20" data-id="element-118" data-mp="v61msxrpx9dl">
          {CASE_STUDIES.map((study, i) => {
          const isReversed = i % 2 === 1;
          return <motion.div key={study.name} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.5
          }} className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-119" data-mp="143lv2qo005xp" data-mpi={i}>
                <div className={isReversed ? 'lg:order-2' : ''} data-id="element-120" data-mp="1mvwf93avhf6h">
                  <h3 className="font-display text-xl font-bold leading-snug text-[var(--color-navy)] sm:text-2xl" data-id="element-121" data-mp="1mtaafbfd9dry">
                    {study.headline}
                  </h3>
                  <p className="mt-5 text-base leading-relaxed text-slate-600" data-id="element-122" data-mp="2bf85ubo1nfnc">
                    {study.description}
                  </p>
                  {study.stats && study.stats.length > 0 && <>
                      <h4 className="font-display mt-8 text-lg font-bold text-[var(--color-navy)]" data-id="element-123" data-mp="21jwr3tcmy8fl">
                        The Results
                      </h4>
                      <div className="mt-4 flex flex-wrap gap-x-12 gap-y-6" data-id="element-124" data-mp="1shx9ozxpl2c4">
                        {study.stats.map(stat => <div key={stat.label} data-id="element-125" data-mp="1dtk9fqrl8xbt">
                            <span className="font-display block text-4xl font-extrabold text-[var(--color-navy)] sm:text-5xl" data-id="element-126" data-mp="1irc2wp7vsri4">
                              {stat.value}
                            </span>
                            <span className="mt-1 block text-sm font-medium text-slate-500" data-id="element-127" data-mp="19qe88xjc1wc7">
                              {stat.label}
                            </span>
                          </div>)}
                      </div>
                    </>}
                </div>
                <div className={isReversed ? 'lg:order-1' : ''} data-id="element-128" data-mp="wsy9y66rsixj">
                  <img src={study.image} alt={study.imageAlt} className="w-full object-contain" data-id="element-129" data-mp="ryu27kpok6ve" />
                </div>
              </motion.div>;
        })}
        </div>
        <div className="mt-14 flex justify-center" data-id="element-130" data-mp="iz6w4lm0acw0">
          <a href="#consultation-form" className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-[var(--color-navy)] px-6 py-4 text-xs font-bold uppercase tracking-wide text-white transition-colors hover:bg-[var(--color-navy-light)] sm:px-8 sm:text-sm" data-id="element-131" data-mp="j0rteizpg9xk">
            Schedule Your Free Consultation
          </a>
        </div>
      </div>
    </section>;
}